import { useEffect, useRef } from "react";

export function useExitIntent(onExitIntent: () => void, isExitIntentEnabled: boolean, isModalOpened: boolean) {
  const wasHiddenRef = useRef(false);
  // Latest-ref so callers can pass inline arrows without re-binding listeners
  // on every parent re-render.
  const onExitIntentRef = useRef(onExitIntent);
  onExitIntentRef.current = onExitIntent;

  useEffect(() => {
    if (!isExitIntentEnabled || isModalOpened) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        wasHiddenRef.current = true;
        return;
      }

      if (document.visibilityState === "visible" && wasHiddenRef.current) {
        wasHiddenRef.current = false;
        onExitIntentRef.current();
      }
    };

    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0) {
        onExitIntentRef.current();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [isExitIntentEnabled, isModalOpened]);
}
